export default {"src":"/_next/static/media/Mississippi.060208b4.svg","height":1085,"width":800,"blurWidth":0,"blurHeight":0};